import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import _ from "lodash";
import { Location } from "../queries/auto-generated/schemas";
import { Coords } from "google-map-react";

export const DEFAULT_CENTER = {
  lat: 33.7483065,
  lng: -118.0848377,
};

export const DEFAULT_ZOOM = 11.29;

export const ZOOMED_IN = 11.5;

interface LocationDataInitialSliceState {
  locations: { [key: string]: Location };
}

interface LocationInitialSliceState {
  data: LocationDataInitialSliceState;
  error?: any;
  loading: boolean;
  selected?: string;
  mapCenter: Coords;
  mapZoom: number;
}

const initialState: LocationInitialSliceState = {
  data: {
    locations: {},
  },
  error: undefined,
  loading: true,
  mapCenter: DEFAULT_CENTER,
  mapZoom: DEFAULT_ZOOM,
};

const location = createSlice({
  name: "locations",
  initialState,
  reducers: {
    load(
      state,
      action: PayloadAction<{
        data?: {
          locations?: Location[];
        };
        error: any;
      }>
    ) {
      if (action.payload?.error) {
        state.error = action.payload?.error;
        return;
      } else {
        state.error = undefined;
      }

      if (!action.payload.data) {
        state.error = "no data"
      }

      if (action.payload.data?.locations) {
        state.data.locations = _.keyBy(action.payload.data?.locations, (o) => {
          return o?.id;
        });
      }

      state.loading = false;
    },
    selectLocation(state, action: PayloadAction<{ locationId: string }>) {
      state.selected = action.payload.locationId;
    },
    updateMapCenter(state, action: PayloadAction<Coords>) {
      state.mapCenter = action.payload;
    },
    updateMapZoom(state, action: PayloadAction<number>) {
      state.mapZoom = action.payload;
    },
    addLocation(state, action: PayloadAction<Location>) {
      const location = action.payload
      state.data.locations[location.id] = location;
    }
  },
});

export default location;
